import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'VOLUNTEER_UPDATE',
    smsDelete : 'VOLUNTEER_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        volunteer: [],

        submitSuccess: false,
        volunteerLoading: false,
        volunteerError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_VOLUNTEER(state, volunteer) {
            state.volunteer = volunteer;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        VOLUNTEER_LOADING (state, loading) {
            state.volunteerLoading = loading;
        },

        VOLUNTEER_ERROR (state, hasError) {
            state.volunteerError = hasError;
        }
    },

    actions: {
        async addVolunteer ({commit, dispatch}, payload) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_volunteer, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchVolunteer')
                return response

            } catch (e) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async fetchVolunteer ({ commit }) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.volunteer_list, config);
                let response = result.data
                commit('SET_VOLUNTEER', response.data);

            } catch(error) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async getVolunteersByUpazila ({ commit }, payload) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.volunteer_list_by_upazila + payload, config);
                let response = result.data
                commit('SET_VOLUNTEER', response.data);

            } catch(error) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async updateVolunteer ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_volunteer + payload.id, payload.volunteer, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchVolunteer')
                return response

            } catch (e) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },
        
        async deleteVolunteer({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.volunteer_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchVolunteer')
            return response
        }
    },

    getters: {}
}
